import { useIntl } from '@leagueplatform/locales';
import {
  StackLayout,
  HeadingText,
  ParagraphText,
  Image,
} from '@leagueplatform/genesis-core';
import customerServiceImg from 'assets/service-advocate-person.svg';

export const CustomerServiceHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      orientation="vertical"
      horizontalAlignment="center"
      css={{ textAlign: 'center', margin: '$two auto' }}
    >
      <Image
        src={customerServiceImg}
        alt="Customer Service Representative"
        width={98}
        height={98}
      />
      <HeadingText
        level="3"
        size="md"
        css={{ marginBottom: '$half', marginTop: '$oneAndHalf' }}
      >
        {formatMessage({ id: 'STR_CUSTOMER_SUPPORT_TITLE' })}
      </HeadingText>
      <ParagraphText>
        {formatMessage({ id: 'STR_CUSTOMER_SUPPORT_DESC' })}
      </ParagraphText>
    </StackLayout>
  );
};
